import { render, staticRenderFns } from "./IconFaq.vue?vue&type=template&id=479ff788&scoped=true"
import script from "./IconFaq.vue?vue&type=script&lang=js"
export * from "./IconFaq.vue?vue&type=script&lang=js"
import style0 from "./IconFaq.vue?vue&type=style&index=0&id=479ff788&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479ff788",
  null
  
)

export default component.exports